import { createFileRoute } from "@tanstack/react-router";
import { KostenDetailPage, kostenDetailHead } from "../components/KostenDetailPage";
import { kostenDetails } from "../lib/kosten-detail-content";

const detail = kostenDetails["casco-aanbouw-kosten"]!;

export const Route = createFileRoute("/casco-aanbouw-kosten")({
  head: () => kostenDetailHead(detail),
  component: () => <KostenDetailPage detail={detail} />,
});
